import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiHttpResponse } from '@app/origami-api/services/base/service.base';
import { Observable } from 'rxjs';

export interface IExportImageRequestData {
  fileToken: string;
  outFileName?: string;
}

@Injectable()
export class ExportService extends ServiceBase {
  serviceUrl = 'ExportService.svc';

  exportIndex(body) {
    return this.origamiPost('/ExportIndex', body, null, null, true);
  }

  exportUsers(body) {
    return this.origamiPost('/ExportUsers', body, null, null, true);
  }

  exportImage(body: IExportImageRequestData): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/ExportImage', body, null, null, true);
  }
}
